import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-contrast",
  "use": "icon-si-glyph-contrast-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-contrast\" id=\"icon-si-glyph-contrast\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>1145</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M8.502,0.115 C4.406,0.115 1.084,3.435 1.084,7.534 C1.084,11.632 4.406,14.954 8.502,14.954 C12.601,14.954 15.923,11.632 15.923,7.534 C15.923,3.436 12.601,0.115 8.502,0.115 L8.502,0.115 Z M7.918,13.242 L7.918,1.827 C11.395,1.827 14.21,4.383 14.21,7.534 C14.21,10.685 11.395,13.242 7.918,13.242 L7.918,13.242 Z\" fill=\"#434343\" class=\"si-glyph-fill\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-contrast.svg
// module id = xxkl
// module chunks = 62